import { render } from "./Page401.vue?vue&type=template&id=2a55f172"
import script from "./Page401.vue?vue&type=script&lang=js"
export * from "./Page401.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__